import React from 'react';
import { Clock } from 'app/BargainWidget/Bargains/WidgetV1/icons/Icons';
import { useBargain } from 'app/BargainWidget/context/BargainContext';
import useCountDown from 'app/BargainWidget/hooks/useCountDown';

const BargainCountDownV1 = () => {
  const { isBargainRuleStarted, translation } = useBargain();
  const { countdown } = useCountDown();

  return (
    <div className="se-mt-4 se-space-y-2.5 bargain-widget-v1-main-countdown">
      <div className="se-flex se-items-center se-gap-2 bargain-widget-v1-main-countdown-description-wrapper">
        <Clock className="se-w-4 se-h-4 se-text-inherit bargain-widget-v1-main-countdown-icon" />
        <span className="se-text-sm se-font-medium se-text-inherit bargain-widget-v1-main-countdown-label">{!isBargainRuleStarted ? translation?.startAt : translation?.closeAt}</span>
      </div>
      <div className="se-grid se-grid-cols-4 se-gap-3 bargain-widget-v1-main-countdown-timer">
        {[
          { value: countdown?.days, label: 'days' },
          { value: countdown?.hours, label: 'hours' },
          { value: countdown?.minutes, label: 'minutes' },
          { value: countdown?.seconds, label: 'seconds' },
        ].map((item, index) => (
          <div key={index} className="se-bg-white/20 se-backdrop-blur-sm se-rounded-xl se-p-2 se-text-center bargain-widget-v1-main-countdown-timer-info">
            <div className="se-text-xl se-font-bold se-text-inherit  bargain-widget-v1-main-countdown-timer-value">{item?.value}</div>
            <div className="se-text-xs se-text-inherit  bargain-widget-v1-main-countdown-timer-label">{translation?.[item?.label] || item?.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BargainCountDownV1;
